import type { ReactElement } from "react";
import { CmtsReportsContainer } from "../../core/containers/domain/reportsRouteContainers.js";
import type { CmtsHostRuntime } from "../../../app/appRuntime.js";

export function Component(props: { readonly runtime: CmtsHostRuntime }): ReactElement {
  return <CmtsReportsContainer runtime={props.runtime} />;
}

export default Component;
